import React from 'react';
export function InstantAccessSection() {
  const items = [{
    emoji: '📅',
    text: 'Die 52 Stunden des Jahres'
  }, {
    emoji: '🤲',
    text: 'Der Korrektur-Guide'
  }, {
    emoji: '📱',
    text: '60 Instagram-Captions'
  }, {
    emoji: '📓',
    text: 'Der Lehrer-Tracker'
  }];
  return <section className="bg-brand-creamDark px-4 py-20" data-id="element-86">
      <div className="mx-auto max-w-4xl text-center" data-id="element-87">
        <h2 className="mb-12 text-3xl font-black text-brand-text md:text-4xl" data-id="element-88">
          📲 Was erhältst du sofort?
        </h2>

        <div className="mb-12 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-89">
          {items.map(item => <div key={item.text} className="flex items-center justify-center gap-3 rounded-2xl border border-white/60 bg-white p-5 shadow-sm" data-id="element-90">
              <span className="text-2xl" aria-hidden="true" data-id="element-91">
                {item.emoji}
              </span>
              <span className="font-bold text-brand-text" data-id="element-92">{item.text}</span>
            </div>)}
        </div>

        <p className="font-serif text-2xl font-bold italic text-brand-green" data-id="element-93">
          Du deckst das Material für das ganze Jahr ab
        </p>
      </div>
    </section>;
}